import dompurify from "isomorphic-dompurify";

import { useTranslations } from "@jti/ui";

import styles from "./PointsDisclaimer.module.scss";

const { sanitize } = dompurify;

type PointsDisclaimerProps = {
  numberOfPoints: number;
};

export const PointsDisclaimer = ({ numberOfPoints }: PointsDisclaimerProps) => {
  const { __ } = useTranslations();

  return (
    <p
      className={styles.pointsDisclaimer}
      dangerouslySetInnerHTML={{ __html: sanitize(__("summarySubscription.collectPoints", [numberOfPoints])) }}
    ></p>
  );
};
